<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="a"
                :pages="[
                    {
                        name: student.full_name,
                        href: route('students.show', student.id),
                    },
                    {
                        name: $t('messages.student_file'),
                        href: route('student-file.edit', student.id),
                    },
                    {
                        name: $t('messages.changes'),
                        href: route('student-file.audit.index', student.id),
                    },
                    {
                        name: audit.updated_at_display,
                        href: null,
                    },
                ]"
            />
        </template>

        {{
            $t('messages.X_made_the_following_changes', {
                person: causer.full_name,
            })
        }}

        <div class="flex flex-col mt-5" v-if="audit.changesTable.length > 0">
            <div class="-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8">
                <div
                    class="align-middle inline-block min-w-full shadow overflow-hidden sm:rounded-lg border-b border-gray-200"
                >
                    <table class="min-w-full divide-y divide-gray-200">
                        <thead>
                            <tr>
                                <th
                                    class="max-w-xs px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                >
                                    {{ $t('messages.description') }}
                                </th>
                                <th
                                    class="px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                >
                                    {{ $t('messages.before') }}
                                </th>
                                <th
                                    class="max-w-xs px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                >
                                    {{ $t('messages.after') }}
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                :class="index % 2 === 0 ? 'bg-white' : 'bg-gray-50'"
                                v-for="(change, index) in audit.changesTable"
                            >
                                <td
                                    class="max-w-sm truncate px-6 py-4 whitespace-nowrap text-sm leading-5 font-medium text-gray-900"
                                >
                                    {{ change.attribute }}
                                </td>
                                <td
                                    class="max-w-sm truncate px-6 py-4 whitespace-nowrap text-sm leading-5 font-medium text-gray-900"
                                >
                                    <span v-if="change.old === '::no_info::'" class="text-gray-400">
                                        {{ $t('messages.no_info') }}
                                    </span>
                                    <span v-else-if="change.type === 'text'">
                                        <span v-html="change.old" class="" />
                                    </span>
                                    <span v-else>
                                        {{ change.old }}
                                    </span>
                                </td>
                                <td
                                    class="max-w-sm truncate px-6 py-4 whitespace-nowrap text-sm leading-5 font-medium text-gray-900"
                                >
                                    <span v-if="change.new === '::no_info::'" class="text-gray-400">
                                        {{ $t('messages.no_info') }}
                                    </span>
                                    <span v-else-if="change.type === 'text'">
                                        <span v-html="change.new" class="" />
                                    </span>
                                    <span v-else>
                                        {{ change.new }}
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <div v-if="audit.addedTags.length > 0" class="mt-3">
            {{ $t('messages.tags_added') }}:

            <span
                v-for="tag in audit.addedTags"
                class="bg-indigo-100 text-indigo-800 mr-3 inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium"
            >
                <span v-if="tag.description === null">
                    {{ tag.display_name }}
                </span>
                <abbr v-else :title="tag.description">
                    {{ tag.display_name }}
                </abbr>
            </span>
        </div>

        <div v-if="audit.removedTags.length > 0" class="mt-3">
            {{ $t('messages.tags_removed') }}:

            <span
                v-for="tag in audit.removedTags"
                class="bg-indigo-100 text-indigo-800 mr-3 inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium"
            >
                <span v-if="tag.description === null">
                    {{ tag.display_name }}
                </span>
                <abbr v-else :title="tag.description">
                    {{ tag.display_name }}
                </abbr>
            </span>
        </div>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';

export default {
    components: {
        PanelPage,
    },
    layout: Layout,
    name: 'Index',
    props: ['student', 'audit', 'causer'],
    data() {
        return {};
    },
    methods: {},
};
</script>
